import { render, staticRenderFns } from "./myFavor.vue?vue&type=template&id=d864970a&"
import script from "./myFavor.vue?vue&type=script&lang=js&"
export * from "./myFavor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports